import React from 'react';
import { Button } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router';
import '../styles/CurrentInventoryStatus.scss';

const ScratchersSectionNav: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const basePath = `/store/${id}/scratchers`;
  const isGamePackReportActive = location.pathname === basePath;

  return (
    <div className="scratchers-section-nav" aria-label="Scratchers section navigation">
      <Button
        size="small"
        variant={isGamePackReportActive ? 'contained' : 'outlined'}
        onClick={() => navigate(basePath)}
      >
        Game & Pack Report
      </Button>
    </div>
  );
};

export default ScratchersSectionNav;
